import './index.css';
import React from 'react';
import { render } from 'react-dom';
import { App } from './App';
render(<App data-id="element-199" data-mp="1wauxclefaf1m" />, document.getElementById('root'));